module.exports = __webpack_public_path__ + "img/mictuning_12.8e560e52.png";